document.addEventListener('DOMContentLoaded', () => {

  function initCountdown(timer) {
    // Prevent multiple initialisations
    if (timer.dataset.initialised === "true") return;
    timer.dataset.initialised = "true";

    const targetDateStr = timer.dataset.countdown || '2025-11-30T23:59:00Z';
    const targetDate = new Date(targetDateStr);

    // Update countdown immediately
    function updateCountdown() {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        timer.innerHTML = `<span class="tf-expired">Winner announced soon!</span>`;
        clearInterval(interval); // stop the countdown
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const seconds = Math.floor((diff / 1000) % 60);

      timer.innerHTML = `
        <div class="tf-countdown-unit"><span class="tf-countdown-number">${days}</span><span class="tf-countdown-label">Days</span></div>
        <div class="tf-countdown-unit"><span class="tf-countdown-number">${hours.toString().padStart(2,'0')}</span><span class="tf-countdown-label">Hours</span></div>
        <div class="tf-countdown-unit"><span class="tf-countdown-number">${minutes.toString().padStart(2,'0')}</span><span class="tf-countdown-label">Minutes</span></div>
        <div class="tf-countdown-unit"><span class="tf-countdown-number">${seconds.toString().padStart(2,'0')}</span><span class="tf-countdown-label">Seconds</span></div>
      `;
    }

    updateCountdown(); // initial call
    const interval = setInterval(updateCountdown, 1000);
  }

  // Watch for dynamically added countdown timers
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.countdown-timer-two').forEach(timer => initCountdown(timer));
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also initialise any timers already on the page
  document.querySelectorAll('.countdown-timer-two').forEach(timer => initCountdown(timer));
});
